export default __webpack_public_path__ + "static/media/pencil_over.c4ec9f3d.svg";